import { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { API_BASE } from "../utils/api";
import { getMyAccountId } from "../utils/config";
import RegisterStepCompany from "./RegisterStepCompany";
import RegisterStepUser from "./RegisterStepUser";

export default function RegisterRequest() {
    const MYACCOUNT_ID = getMyAccountId();
const history = useHistory();
    const [step, setStep] = useState(1);
    const [direction, setDirection] = useState("forward");
    const [form, setForm] = useState({ userCountry: "ECUADOR", });
    const [errors, setErrors] = useState({});
    const [branches, setBranches] = useState([]);
    const [loadingBranches, setLoadingBranches] = useState(false);
    const [loadingRuc, setLoadingRuc] = useState(false);
    const [customerExists, setCustomerExists] = useState(false);
    const [serverMessage, setServerMessage] = useState(null);
    /* =========================
       HANDLE CHANGE
    ========================== */
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "cedula") {
            const clean = value.replace(/\D/g, "");
            setCustomerExists(false);
            setForm((prev) => ({ ...prev, cedula: clean }));
        } else {
            setForm((prev) => ({ ...prev, [name]: value }));
        }

        setErrors((prev) => ({ ...prev, [name]: undefined }));
    };


    /* =========================
       LOAD BRANCHES
    ========================== */
    useEffect(() => {
        const loadBranches = async () => {
            try {
                setLoadingBranches(true);
                const res = await fetch(
                    `${API_BASE}/api-ultra/api/ws/getBranches?myaccount_id=${MYACCOUNT_ID}`
                );
                if (!res.ok) throw new Error();
                const data = await res.json();
                setBranches(data || []);
            } catch {
                console.error("Error cargando sucursales");
            } finally {
                setLoadingBranches(false);
            }
        };

        loadBranches();
    }, [MYACCOUNT_ID]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const saveCompanyAndUser = async () => {
        if (customerExists) return;
        if (!validateForm()) return;
        if (!validateUserForm()) return;

        try {
            const payload = {
                customer: {
                    cedula: form.cedula,
                    companyName: form.companyName,
                    contactName: form.contactName,
                    phone: form.phone,
                    address: form.address,
                    city: form.city,
                    fax: form.fax,
                    eMail: form.eMail,

                    aplicacion: "F",
                    categoryId: "01",
                    contribuyenteE: false,
                    microempresa: false,
                    agenteRetencion: false,
                    exportador: false,
                    supplierTerms: 0,
                    ctype: 1,
                    passport: false,
                    comprasPublicas: false,
                },
                user: buildUserPayload()
            };

            const res = await fetch(
                `${API_BASE}/customers-ultra/api/ws/post_save_customers` +
                `?myaccount_id=${MYACCOUNT_ID}` +
                `&company_id=${form.companyId}` +
                `&bodega_id=${form.bodegaId}` +
                `&first_id=${form.firstId}` +
                `&id_employee=38`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) {
                const data = await res.json();
                alert(data.message || "Error al guardar registro");
                return;
            }

            setServerMessage({
                type: "success",
                text: "Su solicitud ha sido enviada correctamente. Nuestro equipo se pondrá en contacto con usted."
            });
            scrollToTop();
            setTimeout(() => {
                resetForm();
                setServerMessage(null);
            }, 5000);


        } catch (err) {
            console.error(err);
            alert("Error de conexión con el servidor");
        }
    };

    const resetForm = () => {
        setForm({ userCountry: "ECUADOR" });
        setErrors({});
        setCustomerExists(false);
        setStep(1);
        setDirection("forward");
    };


    /* =========================
       VALIDATION STEP 1
    ========================== */
    const validateForm = () => {
        const e = {};
        if (!form.cedula) e.cedula = "Ingrese RUC o cédula";
        if (!form.companyName) e.companyName = "Ingrese razón social";
        if (!form.contactName) e.contactName = "Ingrese contacto";
        //  if (!form.phone) e.phone = "Ingrese celular";
        if (!form.address) e.address = "Ingrese dirección";
        if (!form.city) e.city = "Ingrese ciudad";
        if (!form.fax) e.fax = "Ingrese celular";
        if (!form.eMail) e.eMail = "Ingrese email";
        if (!form.branchId) e.branchId = "Seleccione sucursal";

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    /* =========================
       FETCH RUC
    ========================== */
    const fetchRucData = async (ruc) => {
        try {
            setLoadingRuc(true);
            const res = await fetch(
                `${API_BASE}/customers-ultra/api/ws/getCustomer_UltraEC?myaccount_id=${MYACCOUNT_ID}&ruc=${ruc}`
            );
            if (!res.ok) throw new Error();
            const data = await res.json();

            setForm((prev) => ({
                ...prev,
                cedula: data.cedula || prev.cedula,
                companyName: data.companyName?.trim() || prev.companyName,
                address: data.address?.trim() || prev.address,
                city: data.city || prev.city,
            }));

            if (data.customerId === "YA EXISTE!") {
                setCustomerExists(true);
                setServerMessage({
                    type: "error",
                    text: "Usted ya consta como cliente registrado. Por favor solicite acceso o comuníquese con nuestro equipo de soporte."
                });
            }
        } catch {
            console.error("RUC inválido");
        } finally {
            setLoadingRuc(false);
        }
    };

    /* =========================
       VALIDATE STEP 2
    ========================== */
    const validateUserForm = () => {
        const e = {};
        if (!form.userFirstName) e.userFirstName = "Ingrese su nombre";
        if (!form.userLastName) e.userLastName = "Ingrese su apellido";
        if (!form.username) e.username = "Ingrese usuario";
        if (!form.userEmail) e.userEmail = "Ingrese e-mail";
        if (!form.userPhone) e.userPhone = "Ingrese celular";
        if (!form.password) e.password = "Ingrese contraseña";
        // if (!form.userAddress) e.userAddress = "Ingrese la dirección";
        if (!form.confirmPassword) e.confirmPassword = "Confirme contraseña";

        if (form.password !== form.confirmPassword)
            e.confirmPassword = "No coinciden";

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const buildUserPayload = () => ({
        username: form.username,
        password: form.password,
        eMail: form.userEmail,

        firstName: form.userFirstName,
        lastName: form.userLastName,
        homePhone: form.userPhone,
        birthDate: form.userBirthDate,

        address: form.userAddress,
        city: form.userCity,
        country: form.userCountry,

        companyId: form.companyId,
        bodegaId: form.bodegaId,
    });


    /* =========================
       RENDER
    ========================== */
    return (
        <div className="relative min-h-screen pt-[120px] flex justify-center overflow-hidden">

            {/* 🔥 Background optimizado */}
            <img
                src="https://www.ultra-erp.pro/logos/image-login.png"
                alt="Register background"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
                fetchPriority="high"
                decoding="async"
            />

            {/* Contenido */}
            <div className="relative z-10 w-full max-w-4xl overflow-hidden -mt-4">

                <div
                    key={`${step}-${direction}`}
                    className={`
                        bg-white border border-gray-300 px-8 py-6
                        ${direction === "forward"
                            ? "animate-slideLeft"
                            : "animate-fadeIn"}
                    `}
                >
                    {serverMessage && (
                        <div
                            className={`mb-6 px-4 py-3 text-sm border
                         ${serverMessage.type === "error"
                                    ? "bg-red-50 border-red-300 text-red-700"
                                    : "bg-green-50 border-green-300 text-green-700"}`}
                        >
                            {serverMessage.text}
                        </div>
                    )}


                    {step === 1 && (
                        <>
                            <RegisterStepCompany
                                form={form}
                                errors={errors}
                                branches={branches}
                                loadingBranches={loadingBranches}
                                loadingRuc={loadingRuc}
                                customerExists={customerExists}
                                handleChange={handleChange}
                                fetchRucData={fetchRucData}
                                setForm={setForm}
                                setErrors={setErrors}
                            />

                            <div className="flex justify-between pt-4">
                              <button
      type="button"
      onClick={() => history.goBack()} // goBack() es el equivalente a "Atrás"
      className="border border-gray-300 px-6 py-2 text-sm text-gray-700 hover:bg-gray-50"
    >
                                    Volver
                                </button>

                                <button
                                    type="button"
                                    disabled={customerExists}
                                    onClick={() => {
                                        if (!validateForm()) return;
                                        setDirection("forward");
                                        setStep(2);
                                    }}
                                    className={`text-white text-sm font-semibold px-8 py-2
                                        ${customerExists
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-brand-primary hover:brightness-90"}`}
                                >
                                    Siguiente
                                </button>

                            </div>
                        </>
                    )}

                    {step === 2 && (
                        <RegisterStepUser
                            form={form}
                            errors={errors}
                            setForm={setForm}
                            setErrors={setErrors}
                            onBack={() => {
                                setDirection("back");
                                setStep(1);
                            }}
                            onFinish={saveCompanyAndUser}
                        />
                    )}

                </div>
            </div>
        </div>
    );
}
